"use strict";
exports.__esModule = true;
exports.USER_ROLES = void 0;
var USER_ROLES = {
    SUPER_ADMIN: 'vg_super_admin',
    BANKING_ADMIN: 'vg_banking_admin',
    LENDING_ADMIN: 'vg_lending_admin',
    CREDIT_ASSESSOR: 'vg_credit_assessor',
    LEAD_ASSESSOR: 'vg_lead_assessor',
    LENDING_CUSTOMER_SUPPORT: 'vg_lending_customer_support',
    BROKER: 'vg_broker',
    BANKING_CLIENT: 'vg_banking_client',
    CLIENT: 'vg_client',
    APPLICANT: 'vg_applicant',
    BANKING_PORTFOLIO_ADMIN: 'vg_banking_portfolio_admin',
    TREASURY_ADMIN: 'vg_treasury_admin'
};
exports.USER_ROLES = USER_ROLES;
